




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import { Watch, Prop } from 'vue-property-decorator';
import * as rules from '@/modules/shared/shared/domain/rules';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    components: {
        PhoneField,
        FormNavigationButtons,
    },
})
export default class StepGeneralInformation extends Vue {
    @Prop({ required: true })
    formValues!: {
        generalInformation: {
            subject: number;
            textSubject: string;
            contactId: number;
            firstName: string;
            lastName: string;
            idNumber: string;
            telephoneNumber: string;
            description: string;
        };
        typings: {
            id: number;
            name: string;
            status: number;
            typing: number;
        }[];
    };

    isFormValid: boolean = true;
    modalCheck: boolean = true;
    $refs!: {
        form: any;
    };
    rules: any = rules;

    @Watch('formValues.generalInformation.subject')
    generalInformationSubject(value: any, oldValue: any) {
        this.$emit('getTapeManagementTypingSelected', value);
    }

    sendData() {
        const generalInformation = {
            subject: this.formValues.generalInformation.subject,
            contactId: this.formValues.generalInformation.contactId,
            firstName: this.formValues.generalInformation.firstName,
            lastName: this.formValues.generalInformation.lastName,
            idNumber: this.formValues.generalInformation.idNumber,
            telephoneNumber: this.formValues.generalInformation.telephoneNumber,
            description: this.formValues.generalInformation.description,
        };
        return { generalInformation };
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    previousStep() {
        this.$emit('previousStep');
    }

    mounted() {
        this.formValues.generalInformation.contactId = this.formValues.generalInformation.contactId;
        this.formValues.generalInformation.firstName = this.formValues.generalInformation.firstName;
        this.formValues.generalInformation.lastName = this.formValues.generalInformation.lastName;
        this.formValues.generalInformation.idNumber = this.formValues.generalInformation.idNumber;
        this.formValues.generalInformation.telephoneNumber = this.formValues.generalInformation.telephoneNumber;
    }
}
